import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "react-bootstrap";

const FormDesignHtmlComponent = () => {
  const [modalShow, setModalShow] = useState(false); // State to manage modal visibility

  // Modal component
  const ThankYouModal = (props) => {
    return (
      <Modal
        {...props}
        centered
        size="xl" // Change the size as per your requirement
        backdrop="static"
      >
        <Modal.Header closeButton className="border-bottom-0 position-absolute right-0 z-1">
          {/* <Modal.Title>Modal Title</Modal.Title> */}
        </Modal.Header>
        <Modal.Body className="text-center p-5">
          <h3 className="my-3 text-lg font-semibold text-blue">
            Thank You for filling Up the form. We will Get back to You soon on
            further processing.
          </h3>
          <p className="text-grey-700">
            Want to know about Upcoming events? Click the button below
          </p>
          <Button variant="primary" onClick={props.onHide}>
            Check upcoming events
          </Button>
        </Modal.Body>
      </Modal>
    );
  };

  return (
    <main className="main overflow-hidden">
      <div className="p-3 rounded-3 bg-white">
        <Button variant="primary" onClick={() => setModalShow(true)}>
          Thank You Modal
        </Button>

        {/* Render the modal component */}
        <ThankYouModal
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
      </div>
    </main>
  );
};

export default FormDesignHtmlComponent;
